/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconMapPin, IconRefresh } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { EntityContactType } from '../../../models/core/entities.type';
import entitiesService from '../../../services/core/entities.service';
import theme from '../../../theme';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';

type FormViewProps = {
  idEntidade: number;
  label: string;
  formItem: any;
  idsToBeDisabled: number[];
  disabled: boolean;
  callback(item: EntityContactType | null): void;
  zIndex: number;
};

export default function EntityContactPicker(props: FormViewProps) {
  const [data, setData] = useState<EntityContactType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: EntityContactType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const autoSelectIfSingleResult = (result: EntityContactType[]) => {
    const availableResults = result.filter(
      (x) => !!x.idEntidadeContato && !props.idsToBeDisabled.includes(x.idEntidadeContato)
    );

    if (availableResults.length === 1) {
      confirmActionResult(availableResults[0], true);
    }
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await entitiesService.listContacts({
        idEntidade: props.idEntidade,
      });
      setData(result);
      autoSelectIfSingleResult(result);
    } catch (error: any) {
      showNotification({
        title: `Entidade - Contatos`,
        message: error?.isBusinessException
          ? error.description
          : 'Não foi possível listar os contatos dessa entidade.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.idEntidade > 0) {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        // name={`${row.logradouro}, ${row.numero}${row.complemento ? ` | ${row.complemento}` : ''}`}
        //       nameSize="sm"
        //       description={`${row.bairro} - ${row.cidade} / ${row.codigoEstado} (${row.cep})`}
        const value = `${x.idEntidadeContato}|${x.nome}|${
          x.telefone || x.celular || x.email || x.setor || ''
        }`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idEntidadeContato?.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`entity-contact-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconMapPin size={15} />}
        label={props.label}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idEntidadeContato} - ${x.nome}`,
              value: x.idEntidadeContato!.toString(),
              disabled: props.idsToBeDisabled.includes(x.idEntidadeContato!),
              group: x.nome.toUpperCase()[0],
            };
          })
        ).sort((a, b) => a.group.localeCompare(b.group))}
        clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idEntidadeContato!.toString() === option.value)!;
          return (
            <ProfileCardLink
              id={row.idEntidadeContato!.toString()}
              name={row.nome}
              nameSize="sm"
              description={row.telefone || row.celular || row.email || row.setor}
              descriptionSize="xs"
              descriptionLength={200}
              showLink={false}
            />
          );
        }}
        required
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(data.find((x) => x.idEntidadeContato!.toString() === value) || null, true);
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
